import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function PaymentCancel() {
  const { setIsOpen } = useCart();
  return (
    <div
      data-testid="payment-cancel-page"
      className="min-h-screen flex items-center justify-center px-4 pt-16"
    >
      <motion.div
        className="max-w-md w-full border border-white/10 bg-panel p-12 text-center relative overflow-hidden"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      >
        <div className="scanlines" />
        <XCircle size={44} className="mx-auto mb-6 text-slate-500" />
        <h1 className="font-display text-2xl font-bold uppercase tracking-tight mb-3">
          Checkout cancelled
        </h1>
        <p className="text-sm text-slate-400 leading-relaxed mb-8">
          No charge was made. Your cart is saved exactly as you left it.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            data-testid="resume-checkout-btn"
            onClick={() => setIsOpen(true)}
            className="bg-magma text-white font-display font-bold uppercase tracking-widest text-sm px-8 py-4 glow-magenta hover:bg-[#ff4d87] transition-colors"
          >
            Resume Checkout
          </button>
          <Link
            to="/"
            data-testid="cancel-back-link"
            className="border border-white/15 text-slate-300 font-display font-bold uppercase tracking-widest text-sm px-8 py-4 hover:border-magma hover:text-magma transition-colors"
          >
            Keep Browsing
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
